import { TableBody, styled } from "@mui/material";

export const ASTableV2Body = styled(TableBody)({
  display: "contents"
});
